import React from "react"
import { Provider } from "./src/context/NavBarContext"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>
